import { getDevice } from './utils';
export let configuration = {
    svelteInstance: null,
    appMetadata: null,
    apiKey: null,
    device: getDevice(),
    initialWalletInit: [],
    gas: null
};
export function updateConfiguration(update) {
    configuration = { ...configuration, ...update };
}
